<template>
  <div class="box">
    <div class="form">
      <div class="title">{{ $t('index.retrievePassword') }}</div>
      <div>
        <el-form :model="formInline">
          <template v-if="$i18n.locale === 'zh'">
            <el-form-item label="类型">
              <br>
              <el-radio-group v-model="type" @change="change">
                <el-radio :label="1">姓名+手机号码</el-radio>
                <el-radio :label="2">姓名+证件号码</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="姓名">
              <el-input v-trim v-model="formInline.name" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" v-if="type == 1">
              <el-input v-trim v-model="formInline.mobile" placeholder="手机号码"></el-input>
            </el-form-item>
            <el-form-item label="证件号码" v-else>
              <el-input v-trim v-model="formInline.idnumber" placeholder="证件号码"></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="Type">
              <br>
              <el-radio-group v-model="type" @change="change1">
                <el-radio :label="1">Name + Email</el-radio>
                <el-radio :label="2">Name + IdNumber</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Name">
              <el-input v-trim v-model="formInline.name" placeholder="Name"></el-input>
            </el-form-item>
            <el-form-item label="Email" v-if="type == 1">
              <el-input v-trim v-model="formInline.email" placeholder="Email"></el-input>
            </el-form-item>
            <el-form-item label="IdNumber" v-else>
              <el-input v-trim v-model="formInline.idnumber" placeholder="IdNumber"></el-input>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button @click="getLetter" type="primary">{{ $t('index.btn1') }}</el-button>
            <el-button @click="goback">{{ $t('index.back') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-dialog :title="$t('retrievePassword.title')" :visible.sync="dialogVisible" width="720px"
        :before-close="() => { dialogVisible = false }">
        <div>
          <div class="card" v-for="(item, index) in infoList" :key="index" @click="SelectIdentity(item)">
            <div class="item">
              <div class="lable">{{ $t('retrievePassword.RegistrationCode') }}:</div>
              <div class="value">{{ item.personalInfo.registerNumber || '' }}</div>
            </div>
            <div class="item">
              <div class="lable">{{ $t('retrievePassword.Name') }}:</div>
              <div class="value">{{ item.personalInfo.name || '' }}</div>
            </div>
            <div class="item">
              <div class="lable">{{ $t('retrievePassword.IdNumber') }}:</div>
              <div class="value">{{ item.personalInfo.idnumber || '' }}</div>
            </div>
            <div class="item">
              <div class="lable">{{ $t('retrievePassword.Type') }}:</div>
              <div class="value">{{ item.personalInfo.idtype == 1 ? $t('retrievePassword.Spectator') :
        $t('retrievePassword.medium') || '' }}</div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t('retrievePassword.Cancel') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getLetter } from '@/tools/api'
export default {
  data() {
    return {
      formInline: {},
      dialogVisible: false,
      infoList: [],
      type: 1
    }
  },
  created() { },
  mounted() {
  },
  methods: {
    change(e) {
      this.this.formInline = {}
    },
    change2(e) {
      if (e == 1) {
        this.formInline = {
          email: '',
          name: '',
          enFieldType: 1
        }
      } else {
        this.formInline = {
          email: '',
          name: '',
          enFieldType: 2
        }
      }
    },
    goback() {
      this.$router.go(-1)
    },
    getLetter() {
      if (this.$i18n.locale === 'zh') {
					this.formInline.zhFieldType = this.type
				} else {
					this.formInline.enFieldType = this.type
				}
      getLetter(this.formInline).then(res => {
        if (res.code == 0) {
          this.getInfo(res.data.items)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getInfo(e) {
      if (e.length == 1) {
        let data = e[0]
        sessionStorage.setItem('id', data.id)
        if (data.step == 2) {
          let path = 'realNameAuthentication'
          this.$router.replace({
            name: path,
            params: {
              name: this.formInline.name
            }
          });
        } else if (data.step == 3) {
          this.$router.push({
            path: '/survey'
          })
        } else if (data.step == 4) {
          this.$router.push({
            path: '/payment'
          })
        } else if (data.step == 5) {
          this.$router.push({
            path: '/confirmationLetter'
          })
        }
      } else if (e.length > 1) {
        this.dialogVisible = true
        this.infoList = e
      }
    },
    SelectIdentity(e) {
      this.$confirm(this.$t('retrievePassword.tip'), this.$t('retrievePassword.Tips'), {
        confirmButtonText: this.$t('retrievePassword.OK'),
        cancelButtonText: this.$t('retrievePassword.Cancel'),
        type: 'warning'
      }).then(() => {
        let data = e
        sessionStorage.setItem('id', data.id)
        if (data.step == 2) {
          path = 'realNameAuthentication'
          this.$router.replace({
            name: path,
            params: {
              name: this.formInline.name
            }
          });
        } else if (data.step == 3) {
          this.$router.push({
            path: '/survey'
          })
        } else if (data.step == 4) {
          this.$router.push({
            path: '/payment'
          })
        } else if (data.step == 5) {
          this.$router.push({
            path: '/confirmationLetter'
          })
        }
      })
    },
  }
}
</script>
<style>
.title {
  font-size: 28px;
  margin-bottom: 20px;
}

.card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}

.item {
  display: flex;
  margin: 10px 0;
}

.lable {
  width: 120px;
}
</style>